:host {
  @include generate-font-size-vars;
  @include generate-spacing-vars;

  --footer-background-color: var(--udexCoreSurfaceHigher, #eaecee);
  --footer-color: var(--sapShell_NeutralColor, #475e75);
  --footer-item-color: var(--sapShell_InteractiveTextColor, #354a5f);
  --footer-background-icon: var(--udexColorNeutralWhite, #fff);
  --footer-icon-color: var(--sapShell_InteractiveTextColor	, #354a5f);
  --footer-font-family-fallback: "72 Brand Variable", Arial, Helvetica, sans-serif;
  --footer-font-family: var(--sapFontFamily, --footer-font-family-fallback);
  --footer-social-headline-size: var(--udexTypographyNavigationMediumXLFontSize,16px);
  --footer-navigation-item-size: var(--udexTypographyBodyXSFontSize,14px);
  width: 100%;
}

@import "ds-footer";
